// extracted by mini-css-extract-plugin
module.exports = {"modal-content":"error-allianz-process_modal-content_3ebTO"};